<template>
  <mdb-row>
    <mdb-col>
      <mdb-select
        search
        @getValue="getSelectValue"
        v-if="loadReady"
        v-model="labelOptions"
        :visibleOptions="6"
        :label="$t('unionmember')"
        :placeholder="$t('choose_unionmember')"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbSelect, mdbCol, mdbRow } from "mdbvue";

export default {
  name: "UnionMemberSelection",
  components: {
    mdbSelect,
    mdbCol,
    mdbRow,
  },
  props: {
    defaultSelection: String,
  },
  data: () => ({
    loadReady: false,
    unionmembers: [],
    labelOptions: [],
    unionmemberpath: "/1.0/front/unionmembers",
  }),
  methods: {
    createSelect() {
      this.labelOptions = [];
      this.labelOptions.push({
        text: this.$t("choose_unionmember_none"),
        value: "",
      });
      this.unionmembers.forEach(function (unionmember) {
        this.labelOptions.push({
          text: unionmember.name + ", id:" + unionmember.id,
          value: unionmember.id,
          selected: this.defaultSelection === unionmember.id ? true : false,
        });
      }, this);
    },
    getSelectValue(val) {
      this.$emit("unionmemberid", val);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      if (newVal !== null) {
        this.createSelect();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.$http
      .get(this.unionmemberpath)
      .then((response) => {
        if (response.status == 200) {
          this.unionmembers = response.data.unionmembers;
          this.createSelect();
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        window.__logAxiosErrorIfDebug(error, {
          context: "UnionMemberSelection.vue - mounted",
        });
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>

<style>
</style>
